export interface BitrateOptions {
  qualityIndex: number;
  width: number;
  height: number;
  bitrate: number;
  mediaType: string;
  label?: string;
}
